import config from "@/config";
import app from "@/main";
import configApi from "@/apis/Config.api";
import router, {getBackUrl, registerRoutes} from "@/router/router";
import {getLang} from "@/helpers/helpers";
import Vue from "vue";

const state = {
    locale: "vi",
    website: null,
    menus: [],
    moocMenus: [],
    reloadDashboard: false
};

let locale;

const getters = {
    locale(state) {
        if (!locale) {
            locale = getLang();
            if (locale && locale.length > 1)
                locale = locale.substr(0, 2);
        }

        if (locale && locale.length)
            return locale;

        return config.locale.default;
    },
    website: state => state.website,
    menus: state => state.menus.map(x => ({...x, show: false})),
    moocMenus: state => state.moocMenus.map(x => ({...x, show: false})),
    isK12: state => state.website?.isK12,
    isK12OrBusiness: state => state.website?.isK12OrBusiness,
    isUniversity: state => state.website?.isUniversity,
    isMoocs: state => state.website?.isMoocs,
    idSite: state => state.website?.idSite,
    showManualAttendance: state => state.website?.showManualAttendance,
    reloadDashboard: state => state.reloadDashboard,
};
const mutations = {
    SET_LOCALE: (state, payload) => {
        app.$i18n.locale = payload;
        state.locale = payload;
    },
    SET_WEBSITE: (state, payload) => state.website = payload,
    SET_MENUS: (state, payload) => state.menus = payload,
    SET_MOOC_MENUS: (state, payload) => state.moocMenus = payload,
    SET_SITE_LOGO_URL: (state, payload) => state.website.logoUrl = payload,
    SET_SITE_TITTLE: (state, payload) => state.website.name = payload,
    SET_SITE_FAVICON: (state, payload) => state.website.faviconUrl = payload,
    SET_RELOAD_DASHBOARD: (state, payload) => state.reloadDashboard = payload
};
const actions = {
    setLocale: async ({commit, dispatch}, payload) => {
        commit("SET_LOCALE", payload);
        commit("SET_WEBSITE", null);
        location.href = config.urls.api + "/Home/ChangeLanguage?code=" + {"vi": "vi-VN", "en": "en-US"}[payload];
    },
    getConfig: async ({commit, dispatch}, languageCode) => {
        const ssoToken = window.localStorage.getItem("ssoToken");
        const response = await configApi.get({ssoToken: ssoToken}, languageCode);
        if (!response || response.error) {
            return {url: config.urls.login};
        }

        const data = response.data;
        const user = data.user;
        const examToken = data.examToken;

        commit("SET_WEBSITE", data.website);
        commit("SET_MENUS", data.menus);
        commit("SET_MOOC_MENUS", data.moocMenus);
        dispatch("auth/setUser", user, {root: true});
        dispatch("auth/setExamToken", examToken, {root: true});

        if (languageCode)
            return;

        registerRoutes();

        try {
            const backUrl = getBackUrl();
            if (backUrl && backUrl.length > 0)
            {
                const index = backUrl.indexOf("#");
                const path = backUrl.substr(index + 1);
                if (index >= 0 && path !== router.app.$route.fullPath) {
                    return router.push({path: path});
                }
            }
        } catch (e) {
            console.log(e);
        }

        // return router.push({name: "Dashboard"});
    },
    setSiteInfo: ({commit}, payload) => {
        commit("SET_SITE_LOGO_URL", payload.logo.url);
        commit("SET_SITE_TITTLE", payload.title);
        commit("SET_SITE_FAVICON", payload.favicon.url);

        if (payload.favicon.url !== "") {
            document.querySelectorAll("[rel='icon']").forEach(x => x.href = payload.favicon.url);
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
